module.exports = __webpack_public_path__ + "media/fonts/UHC_Sans/UHCSans-Regular-ed5a622aed1f440468c7d6f28200c77f.eot";